"use strict"

import React from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  scale_axis_without_outliers: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "graphing.scale.access.without.outliers",
        })
      : "Scale Axis Without Outliers",
}

export default function ToggleOutliersButtons({ toggleAvailable, plotEntry, graphKey = {}, intl, small }) {
  const canToggleOutliers =
    !graphKey.special || ["multi", "site-wide", "obs-vs-obs"].includes(graphKey.special)
  const observations = (graphKey.special === "site-wide" ? graphKey.tags : graphKey.observations) || []
  const title = registration["scale_axis_without_outliers"](intl)
  const op = Object.assign({}, graphKey)
  const sizeClass = small ? "btn-sm" : ""

  const toggleOutliers = (y2 = false) => {
    const axisFilterSetting = !y2 ? "outlierFilter" : "outlierFilter2"

    plotEntry.plotConfigUpdater({
      ...op,
      [axisFilterSetting]: !op[axisFilterSetting],
    })
  }

  return (
    <>
      {canToggleOutliers && (
        <>
          <Button
            className={op.outlierFilter ? `btn-selected ${sizeClass}` : sizeClass}
            variant={"outline-primary"}
            disabled={!toggleAvailable}
            title={title}
            onClick={(e) => {
              e.preventDefault()
              toggleOutliers()
            }}
          >
            {op.special !== "obs-vs-obs" ? (
              <>
                Y<sub>1</sub>
              </>
            ) : (
              <>X&Y</>
            )}
            <span className={"fa fa-filter"} />
          </Button>
          {canToggleOutliers && observations.filter((obs) => obs.axis2).length > 0 && (
            <Button
              className={op.outlierFilter2 ? `btn-selected ${sizeClass}` : sizeClass}
              variant={"outline-primary"}
              disabled={!toggleAvailable}
              title={title}
              onClick={(e) => {
                e.preventDefault()
                toggleOutliers(true)
              }}
            >
              Y<sub>2</sub>
              <span className={"fa fa-filter"} />
            </Button>
          )}
        </>
      )}
    </>
  )
}
